export class Permissions {

    userPermissions = []

    constructor(permissions) {
        this.userPermissions = permissions
    }

    hasAny(...permissions) {
        return permissions.some(permission => this.userPermissions.includes(permission));
    }

    static DFPDashboard() {
        return process.env.VUE_APP_DFP_DASHBOARD_ACCESS_ROLE || 'dfp_dashboard_access';
    }
}